import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";
import _ from "lodash";
import lscache from "lscache";
import { terminal } from "../../../../../config/Constantes";

export default class CardContainerPaiStore {
  @observable expandido;
  tipoAgenda;

  //TODO - Observar impactos da retirada do tiposContainer desta store
  @observable tiposContainer;
  @observable armadores;
  @observable portos;
  @observable destinos;
  @observable editandoBooking;
  @observable previaNaoExiste;
  @observable previaNaoExisteFilho;
  @observable arrayJaVistoEditar;

  /* Containers */
  @observable ISOs;
  @observable categorias;
  @observable tiposDeLacre;
  @observable todosTiposDeLacre;
  @observable tiposMercadoria;

  @observable portosBloqueado;
  @observable ISOsBloqueado;
  @observable bloqueadoRespOvacao;
  @observable tiposMercadoriaBloqueado;

  @observable listaMensagens;
  @observable atualizandoClientes;
  @observable atualizandoNcm;
  @observable atualizandoRespOva;
  @observable atualizandoContainer;
  @observable atualizaCodCtnr;
  @observable tipoConsultaCntr;
  @observable loadingCtnrFromExternalApi;

  containerModificando;

  constructor(tipoAgenda) {
    this.tipoAgenda = tipoAgenda;
    this.loadingCtnrFromExternalApi = [];
    this.tiposContainer = [];
    this.armadores = [];
    this.portos = [];
    this.destinos = [];
    this.editandoBooking = true;
    this.previaNaoExiste = false;
    this.previaNaoExisteFilho = true;
    this.arrayJaVistoEditar = [];

    // Containers
    this.ISOs = false;
    this.categorias = [];
    this.tiposDeLacre = [];
    this.todosTiposDeLacre = [];
    this.tiposMercadoria = [];

    this.portosBloqueado = true;
    this.ISOsBloqueado = true;
    this.bloqueadoRespOvacao = [];
    this.tiposMercadoriaBloqueado = true;

    this.atualizandoClientes = false;
    this.atualizandoRespOva = false;
    this.atualizandoNcm = false;
    this.atualizandoContainer = false;
    this.atualizaCodCtnr = "";
    this.expandido = true;

    this.listaMensagens = false;

    this.desbloqCamposMercadoria = [
      "Temperatura_Desloqueado",
      "Umidade_Desloqueado",
      "Ventilacao_Desloqueado",
      "UN_Desloqueado",
    ];
    this.camposMercadoria = ["ValUmid", "ValVent", "ValTmpIdea", "IdUn"];

    this.service = new AgendamentoContainerService();

    this.tipoConsultaCntr = "Geral";
  }

  atualizaTipoConsultaCntr(tipoConsultaCntr) {
    console.log("atualizaTipoConsultaCntr", tipoConsultaCntr)
    this.tipoConsultaCntr = tipoConsultaCntr;
  }

  atualizaContainer(status) {
    this.atualizandoContainer = status;
  }

  setContainerAtualizado(codCtnr) {
    this.atualizaCodCtnr = codCtnr;
  }

  fecharModais = () => {
    this.listaMensagens = false;
  };

  fecharModaisErro = () => {
    this.listaMensagens = false;
    this.inserindoEmModal = false;
    this.modalFimAgendamento = false;
    this.previaNaoExiste = false;
  };

  clickExpandir = (booking) => {
    this.expandido = !this.expandido;
    if (this.ISOs && this.ISOs.length == 0) {
      this.carregarISOs(booking.CdTipoCntr, booking.NumBooking);
    }
  };

  clickEsconder = () => {
    this.expandido = !this.expandido;
  };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/stores/CardContainerPaiStore.js